// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/vat-summary-schema',
  type: 'object',
  required: ['vatRate', 'vatAmount', 'netAmount'],
  nullable: true,
  properties: {
    vatRate: {
      type: 'number',
    },
    vatAmount: {
      type: 'number',
    },
    netAmount: {
      type: 'number',
    },
  },
} as IJSONSchema;

export default schema;
